module.exports = __webpack_public_path__ + "img/alarm-snooze.18e1a98b.svg";